import StyledComponent from 'styled-components';

const Container = StyledComponent.div`
min-height: 80%;
overflow-y: scroll;
padding: 15px 15px;

.friends-content
{
  text-align: left;
}
.friends-title
{
  color: rgb(35, 83, 115);
}
.preview-title
{
  color: rgb(35, 83, 115);
}
.create-form
{
  display: flex;
  align-items: center;
  justify-content: center;
}
.select-control
{
  width: 100%

  @media(min-width: 600px)
  {
    width: 55%;
  }
}
.print-btn {
  margin-top: 100px;
}
.select-label
{
  width: 100%

  @media(min-width: 600px)
  {
    width: 55%;
  }
}
.selector
{
  width: 100%

  @media(min-width: 600px)
  {
    width: 55%;
  }
}
.main-btn-section
{
  align-self: flex-end;
}
.bottom-section
{
  flex-direction: row;
}
.info-message
{
  white-space:pre-wrap;
}`;

export default Container;
